/**
 * Высота полос фиксированной шапки сверх самого меню (h-16 = 4rem).
 *
 * Полосы сверху вниз:
 *   imp  — «Вы вошли как … — Вернуться в админку» (ImpersonationBar), самая
 *          верхняя, на всех страницах;
 *   top  — промо-плашка НАД меню (PromoStickyBar: гость, нет даты рождения,
 *          выключена рассылка);
 *   days — счётчик подарочных дней ПОД меню (ProDaysStrip внутри <nav>).
 *
 * --imp-h       — высота полосы «Войти как»: на неё съезжает промо-плашка.
 * --promo-top-h — всё, что над меню (imp + top): на неё съезжает само меню.
 * --promo-bar-h — сумма всех трёх: на неё съезжает документ (body padding-top
 *   в index.css), и её же к 4rem прибавляют все отступы «под шапкой»
 *   (scrollUnderHeader, scrollMarginTop). Значение — всегда число в px:
 *   несколько мест читают его через parseInt/parseFloat.
 */
const parts = { imp: 0, top: 0, days: 0 };

export function setHeaderBarHeight(part, px) {
  parts[part] = Math.max(0, Math.round(px || 0));
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty('--imp-h', `${parts.imp}px`);
  root.style.setProperty('--promo-top-h', `${parts.imp + parts.top}px`);
  root.style.setProperty('--promo-bar-h', `${parts.imp + parts.top + parts.days}px`);
}

/** Мерить элемент и держать его высоту в части part, пока он на экране. */
export function trackHeaderBar(part, el) {
  if (!el) {
    setHeaderBarHeight(part, 0);
    return () => {};
  }
  const apply = () => setHeaderBarHeight(part, el.offsetHeight);
  apply();
  let ro = null;
  if (typeof ResizeObserver !== 'undefined') {
    ro = new ResizeObserver(apply);
    ro.observe(el);
  }
  window.addEventListener('resize', apply);
  return () => {
    window.removeEventListener('resize', apply);
    if (ro) ro.disconnect();
    setHeaderBarHeight(part, 0);
  };
}
